import styled from 'styled-components';

export const ResultsMetaDataStyle = styled.div`
    position: absolute;
    left: 230px;
    display: flex;
    gap: 10px;
    font-size: 14px;
    font-weight: bolder;
    color: #171717;
`;